<template>
    <div>
        <el-form
            :inline="true"
            :model="search"
            class="demo-form-inline"
        >
            <el-form-item label="销售员姓名">
                <el-input v-model="search.name" placeholder="输入销售员姓名" @input="changeName"/>
            </el-form-item>
        </el-form>
        <div style="max-height: 485px; overflow: auto">
            <el-table
                v-loading="listLoading"
                :data="list"
                border
                fit
                highlight-current-row
                @row-dblclick="selectEmpDb"
                @row-click="selectEmp"
            >
                <el-table-column width="35" align="center">
                    <template slot-scope="{ row }">
                        <el-radio v-model="radio" :label="row.id">{{
                            ""
                        }}</el-radio>
                    </template>
                </el-table-column>
                <template v-for="(col, index) in cols">
                    <el-table-column
                        :key="index"
                        align="left"
                        :label="col.label"
                        :width="col.width"
                    >
                        <template slot-scope="{ row }">
                            <span>{{ row[col.prop] }}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <el-pagination
             style="margin-top: 15px;text-align: right;"
            :current-page="search.page"
            :page-sizes="[20, 50, 120, 250]"
            :page-size="search.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :pager-count="5"
        />
    </div>
</template>

<script>

export default {
    props: {
        emp: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            cols: [
                {
                    prop: "number",
                    label: "编号",
                    width: 60,
                },
                {
                    prop: "name",
                    label: "姓名",
                },
                {
                    prop: "phone",
                    label: "手机号",
                },
            ],
            list: [],
            listLoading: false,
            radio: "",
            search: {
                name: "",
                page: 1,
                limit: 20,
            },
            total: 0,
        };
    },
    created() {
        this.getList();
    },
    methods: {
        async getList() {
            this.listLoading = true;
            this.$api.employeelistEmployee(this.search).then((res) => {
                if (res.data.code == 1) {
                    this.list = res.data.data;
                    this.total = res.data.count;
                }
            });
            this.listLoading = false;
        },
        changeName(){
            this.getList();
        },
        defaultSelect() {
            this.radio = this.emp;
        },
        selectEmp(row) {
            this.radio = row.id;
        },
        selectEmpDb(row) {
            this.radio = row.id;
            this.checkEmployee();
        },
        checkEmployee() {
            this.list.map((item) => {
                if (item.id === this.radio) {
                    this.$emit("close", item);
                }
            });
        },
    },
};
</script>
